"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HandSelect = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var HandSelect = function HandSelect(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48 6.648a1.672 1.672 0 01-.352-1.241 1.69 1.69 0 012.998-.851l1.26 1.592c.022-.018.044-.037.067-.054.165-.13.35-.231.547-.3V2.4a.8.8 0 00-.8-.8H1.6a.8.8 0 00-.8.8V8a.8.8 0 00.8.8h3.583L3.48 6.648zm4.47.072a1.103 1.103 0 011.202-.11 1.1 1.1 0 011.062-.81c.178-.001.356.042.517.126a1.098 1.098 0 011.065-.812c.326 0 .65.144.869.42l.138.174 1.237 1.565.349.44a3.763 3.763 0 01-.618 5.285 6.16 6.16 0 01-4.54 1.29 8.056 8.056 0 00-1.585-.028l-1.7.139h-.031a.393.393 0 01-.384-.311 1.419 1.419 0 011.1-1.68l1.336-.278a.462.462 0 00.268-.738l-1.007-1.273.01-.009-3.13-3.958a.887.887 0 011.39-1.1l2.035 2.572c-.01-.339.13-.677.417-.904z",
    fill: "currentColor"
  }));
};

exports.HandSelect = HandSelect;
var _default = HandSelect;
exports.default = _default;